import {Component, ReactNode} from 'react';
import './SilhouettePopup.scss';
import {
    Container,
    Dialog, DialogContent,
    DialogTitle,
    IconButton
} from '@mui/material';
import {GameContext} from '../content/GameContext';
import {Close} from '@mui/icons-material';

export interface HelpPopupProps<Schema> {
    show: boolean;
    onClose: () => void;
    gameContext: GameContext<Schema>;
}

export class HelpPopup<Schema> extends Component<HelpPopupProps<Schema>> {
    override render(): ReactNode {
        const HelpMessage = this.props.gameContext.getHelpContent();
        return <Dialog
            open={this.props.show}
        >
            <Container>
                <DialogTitle>
                    <IconButton aria-label="close" onClick={this.props.onClose} sx={{
                        position: 'absolute',
                        right: 4,
                        top: 4,
                        color: "primary.main"
                    }}>
                        <Close/>
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <HelpMessage/>
                </DialogContent>
            </Container>
        </Dialog>;
    }
}
